{
  "FileUpload_DragAndDrop": "Déposez le fichier ici ou cliquez pour sélectionner le fichier",
  "FileUpload_DropFileHere": "Déposez le fichier ici",
  "FileUpload_Accepted": "Le dossier sera accepté",
  "FileUpload_Rejected": "Le dossier sera rejeté",
  "FileUpload_SelectedFile": "Fichier sélectionné : {}",
  "FileUpload_Validation_OverMaxSize": "La taille du fichier dépasse la taille maximale autorisée de {}",
  "FileUpload_Validation_MaxDimensions": "Les dimensions du fichier dépassent les dimensions maximales autorisées de {}x{}",
  "FileUpload_Validation_MinDimensions": "Les dimensions du fichier sont inférieures aux dimensions minimales autorisées de {}x{}",
  "FileUpload_Validation_NotTransparent": "L'arrière-plan du fichier n'est pas transparent",
  "NAME": "FileUploadLanguage"
}